import CharacterCount from '@tiptap/extension-character-count';
import Color from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import LinkExtension from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

import { CharCount, EditorBox, ErrorText } from './styles';
import { Toolbar } from './Toolbar';

export function isRichTextEmpty(html: string): boolean {
  return html.replace(/<[^>]*>/g, '').trim().length === 0;
}

interface RichTextEditorProps {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  charLimit?: number;
  error?: boolean;
  helperText?: string;
}

export function RichTextEditor({
  value,
  onChange,
  placeholder,
  charLimit = 250,
  error,
  helperText,
}: RichTextEditorProps): JSX.Element {
  const editor = useEditor({
    extensions: [
      StarterKit,
      TextStyle,
      Color,
      Underline,
      Highlight.configure({ multicolor: true }),
      TextAlign.configure({ types: ['paragraph'] }),
      LinkExtension.configure({ openOnClick: false }),
      Placeholder.configure({ placeholder }),
      CharacterCount.configure({ limit: charLimit }),
    ],
    content: value,
    onUpdate: ({ editor: updatedEditor }) => {
      onChange(updatedEditor.getHTML());
    },
  });

  const characters = editor?.storage.characterCount.characters() ?? 0;

  return (
    <EditorBox hasError={Boolean(error)}>
      <Toolbar editor={editor} />
      <EditorContent editor={editor} className="rich-text-content" />
      <CharCount>
        {characters}/{charLimit}
      </CharCount>
      {error && helperText && <ErrorText>{helperText}</ErrorText>}
    </EditorBox>
  );
}
